import { create } from "zustand";
import { handlePasswordUpdate } from "../../apiEndpoints/navutils";

type State = {
    // fields
    newPassword: string;
    newcPassword: string;
    newPasswordeyeOpen: boolean;
    newCPasswordEyeOpen: boolean;
    updating: boolean;

    // setters
    setNewPassword: (value: string) => void;
    setNewCPassword: (value: string) => void;
    toggleNewPasswordEye: () => void;
    toggleNewCPasswordEye: () => void;

    // action
    updatePassword: (taskCompleted: () => void) => Promise<void>;
    toggleUpdating: () => void;
};

export const useResetPasswordStore = create<State>((set, get) => ({
    // initial state
    newPassword: "",
    newcPassword: "",
    newPasswordeyeOpen: false,
    newCPasswordEyeOpen: false,
    updating: false,

    // setters
    setNewPassword: (value: string) =>
        set({ newPassword: value }),

    setNewCPassword: (value: string) =>
        set({ newcPassword: value }),

    toggleNewPasswordEye: () =>
        set((state) => ({ newPasswordeyeOpen: !state.newPasswordeyeOpen })),

    toggleNewCPasswordEye: () =>
        set((state) => ({ newCPasswordEyeOpen: !state.newCPasswordEyeOpen })),

    // update password action
    updatePassword: async (taskCompleted: () => void) => {
        set({ updating: true })
        const { newPassword, newcPassword } = get();
        const result = await handlePasswordUpdate("forgot", newPassword, newcPassword);
        set({ updating: false })
        if (result) {
            taskCompleted()
        }

    },
    toggleUpdating: () =>
        set((state) => ({ updating: !state.updating })),

}));